import React, {Component} from 'react';

import {inject, observer} from 'mobx-react'
import {MODAL_QUESTION_INFO} from "../store/const";

@inject("store")
@observer
export default class InfoFooterApp extends Component {
    constructor(props) {
        super(props);
    }

    showModal = () => {
        this.props.store.showModal(MODAL_QUESTION_INFO)
    };

    render() {
        let {questionCount, hasResult} = this.props.store;

        const shownQuestionCount = hasResult ? '' : questionCount;

        let infoText = 'Mere info til dette spørgsmål';
        
        if (questionCount === 1) infoText = "Mere info om Fristberegneren";
        if (hasResult) infoText = 'Mere info til resultatet';

        return (
            <div className="informationFooter" onClick={this.showModal}>
                <div className="informationFooterContent">
                    {!hasResult &&
                        <span className="index">{shownQuestionCount}</span>
                    }
                        <span className="text">{infoText} -</span><span className="link"> klik her</span>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/QuestionInfoFooter.js